/**
 * API клієнт для doc.product_disassemblies — Розукомплектація номенклатури.
 * Permission: production.assembly.manage (reuse домену комплектації).
 * alembic 0262 — підфіча карткою #3 «Комплектація».
 */
import { api } from './client';
import type { Page } from './catalogs';
import type { CancellableState } from './cancellation';

export interface ProductDisassemblyComponentIn {
  line_number: number;
  nomenclature_id: string;
  quantity: string;
  uom_id?: string | null;
  // Доля собівартості набору % (сума=100 по документу).
  cost_percentage: string;
}

export interface ProductDisassemblyComponent extends ProductDisassemblyComponentIn {
  id: string;
  cost_per_unit: string | null;
  total_cost: string | null;
}

export interface ProductDisassemblyListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  warehouse_id: string;
  disassembled_nomenclature_id: string;
  disassembled_quantity: string;
  total_cost: string | null;
  posted: boolean;
  deletion_mark: boolean;
  external_source?: string | null;
  state?: CancellableState;
}

export interface ProductDisassembly extends ProductDisassemblyListItem {
  specification_id: string | null;
  posted_at: string | null;
  comment: string | null;
  project_id: string | null;
  components: ProductDisassemblyComponent[];
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
}

export interface ProductDisassemblyCreate {
  organization_id: string;
  document_number?: string | null;
  document_date: string;
  warehouse_id: string;
  disassembled_nomenclature_id: string;
  disassembled_quantity: string;
  // Опціональна ASSEMBLY-специфікація для автопідстановки складу+долей.
  specification_id?: string | null;
  comment?: string | null;
  project_id?: string | null;
  components?: ProductDisassemblyComponentIn[];
}

export type ProductDisassemblyUpdate = Partial<Omit<ProductDisassemblyCreate, 'organization_id'>>;

export const productDisassemblies = {
  list: (params?: { organization_id?: string; posted?: boolean; limit?: number; offset?: number }) =>
    api.get<Page<ProductDisassemblyListItem>>('/product-disassemblies', { params }).then((r) => r.data),
  get: (id: string) => api.get<ProductDisassembly>(`/product-disassemblies/${id}`).then((r) => r.data),
  create: (payload: ProductDisassemblyCreate) =>
    api.post<ProductDisassembly>('/product-disassemblies', payload).then((r) => r.data),
  update: (id: string, payload: ProductDisassemblyUpdate) =>
    api.patch<ProductDisassembly>(`/product-disassemblies/${id}`, payload).then((r) => r.data),
  remove: (id: string) => api.delete(`/product-disassemblies/${id}`).then(() => undefined),
  post: (id: string) => api.post<ProductDisassembly>(`/product-disassemblies/${id}/post`).then((r) => r.data),
  unpost: (id: string) => api.post<ProductDisassembly>(`/product-disassemblies/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/product-disassemblies/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
